import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from "@angular/material/dialog";
import { ConsultantFormComponent } from 'src/app/WebView/FormWebView/query/consultant-form/consultant-form.component';
import { APISchedulerService } from "src/services/api-services/api-scheduler-service";
import { HelperService } from "src/services/helperService";
import { TranslateService } from "@ngx-translate/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: 'app-information-modal',
    templateUrl: './information-modal.component.html',
    styleUrls: ['./information-modal.component.sass'],
    standalone: false
})

export class InformationModalComponent implements OnInit {

     constructor(
          public dialogRef: MatDialogRef <ConsultantFormComponent>,
          @Inject (MAT_DIALOG_DATA) public appointmentId:any,
          public schedulerService: APISchedulerService, 
          private helperService: HelperService,
          private translate: TranslateService,
          private router: Router,
          private route: ActivatedRoute,
       ) 
    { }

    ngOnInit(): void { }

    cancel() {
        this.dialogRef.close()
    }
}